import { MovieClip, View, ViewOpts } from '@play-co/timestep-core/ui';

/** MovieClip names in the supplied popup's display order. */
export const STICKER_IDS = [
  'sticker_001',
  'sticker_002',
  'sticker_003',
  'sticker_004',
  'sticker_005',
  'sticker_006',
  'sticker_007',
  'sticker_008',
  'sticker_009',
] as const;

/** A non-interactive sticker preview that returns to its first frame after playing. */
export default class Sticker extends View {
  /** Animation displayed inside the preview's bounds. */
  private readonly movieclip: MovieClip;

  /**
   * Fit a sticker into the requested preview bounds without stretching it.
   * @param opts View layout and the converted sticker to display.
   */
  constructor(opts: ViewOpts & { stickerId: (typeof STICKER_IDS)[number] }) {
    // Keep the wrapper's bounds independent of the animation's native size.
    super({ width: 370, height: 300, ...opts, canHandleEvents: false });

    // Exported frames use a centered origin and share a 370 by 300 canvas.
    this.movieclip = new MovieClip({
      superview: this,
      url: `assets/ui/stickers/movieclips/${opts.stickerId}`,
      x: this.style.width / 2,
      y: this.style.height / 2,
      scale: Math.min(this.style.width / 370, this.style.height / 300),
      canHandleEvents: false,
    });
  }

  /** Play from the beginning once, then leave the first frame visible. */
  public playOnce(): void {
    // Play the preview animation once.
    this.movieclip.play('loop', () => {
      // MovieClip stops before invoking this callback; reset its displayed frame.
      this.movieclip.frame = 0;
      this.movieclip.framesElapsed = 0;
    });
  }
}
